import './App.css';
import { createBrowserHistory } from 'history';
import { renderRoutes } from 'react-router-config';
import { Router } from 'react-router-dom';
import routes from './routes';

function App() {

  const history = createBrowserHistory();

  return (
    <Router history={history}>
      {renderRoutes(routes)}
    </Router>
  );
}

export default App;
